module.exports = __webpack_public_path__ + "media/images/admin/icons/box-3f9b97903ba683a37d6de0034adc621c.svg";